'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'comet';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e003';
var svgPathData = ['M0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L480.8 234.3c6.5-11.1-2.2-25-15.1-24l-29.3 2.3L511.1 18.3c.6-1.5 .9-3.2 .9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3 .3-4.8 .9L299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309zm69.7-18.1c.1-.8 .3-1.6 .6-2.5c1.9-5.8 6.9-10 12.9-10.9c21.8-3.2 43.5-6.3 65.3-9.5c9.7-19.7 19.5-39.4 29.2-59.2c2.7-5.5 8.3-8.9 14.3-8.9s11.7 3.5 14.3 8.9c9.7 19.7 19.5 39.4 29.2 59.2l65.3 9.5c6 .9 11 5.1 12.9 10.9s.3 12.2-4 16.4c-15.7 15.3-31.5 30.7-47.2 46c3.7 21.7 7.4 43.3 11.2 65c1 6-1.4 12.1-6.4 15.7s-11.5 4.1-16.8 1.2c-19.5-10.2-38.9-20.5-58.4-30.7c-19.5 10.2-38.9 20.5-58.4 30.7c-5.4 2.8-11.9 2.4-16.8-1.2s-7.4-9.6-6.4-15.7l11.2-65-47.2-46c-1.6-1.5-2.8-3.3-3.6-5.3c-.4-1-.7-2-.9-3c-.2-.8-.3-1.6-.2-1.6c-.1-.8-.1-.8-.1-1.6c0-.8 0-1 0-1.2c0-.4 .1-.8 .1-1.2z', 'M206.3 208.9c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-29.2 59.2-65.3 9.5c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l47.2 46-11.2 65c-1 6 1.4 12.1 6.4 15.7s11.5 4.1 16.8 1.2L192 402.1l58.4 30.7c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.7l-11.2-65 47.2-46c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-65.3-9.5-29.2-59.2z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faComet = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;